<div class="process-page">
    <header class="toolbar">
        <div>
            <h1>{{ heading }}</h1>
            <span>{{ subtitle }}</span>
        </div>
        <!-- the models and their colours are listed beside the graph by the page showing it -->
        <button (click)="layoutGraph()">Layout</button
        ><button (click)="fitGraph()">Fit</button>
    </header>
    <div #graphHost class="graph-host"></div>
</div>
